import axios from 'axios';

export default {
	recuperar(p_email, p_usuario, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_rubros.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_tiporec": p_tiporec
				  })
			})
	},
	
	leer_archivo(p_email, p_usuario, p_archivo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_rubros.leer_archivo",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_archivo": p_archivo
				  })
			})
    },

	recuperar_errores(p_email, p_usuario, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_rubros.recuperar_errores",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_tiporec": p_tiporec
				  })
			})
	},
	
	eliminar(p_email, p_usuario, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_rubros.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
    },
    

}